
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { LocationFormData } from "@/components/admin/locations/schemas/locationFormSchema";
import { CampLocation } from "@/types/campLocation";
import { LocationFormContent } from "@/components/admin/locations/components/LocationFormContent";
import { Organization } from "@/types/organization";
import { OrganizationInfoSection } from "../organization/OrganizationInfoSection";

interface DetailsTabProps {
  form: UseFormReturn<LocationFormData>;
  location: CampLocation;
  onSubmit: () => Promise<void>;
  organizationData: Organization | null | undefined;
  aboutOrgText: string;
  setAboutOrgText: (value: string) => void;
  staffingText: string;
  setStaffingText: (value: string) => void;
}

export const DetailsTab: React.FC<DetailsTabProps> = ({
  form,
  location,
  onSubmit,
  organizationData,
  aboutOrgText,
  setAboutOrgText,
  staffingText,
  setStaffingText
}) => {
  return (
    <>
      <LocationFormContent form={form} onSubmit={onSubmit} location={location} hideAgeGroups={true} isWelcomeScreen={true} />
      
      {organizationData && (
        <OrganizationInfoSection
          organization={organizationData}
          aboutOrgText={aboutOrgText}
          setAboutOrgText={setAboutOrgText}
          staffingText={staffingText}
          setStaffingText={setStaffingText}
        />
      )}
    </>
  );
};
